export * from './service-for-discount-modal.component';